import * as React from "react"

import Autocomplete from "./Autocomplete/Autocomplete"
import type { Props as AutocompleteProps } from "./Autocomplete/Autocomplete"
import { FormField, Option } from "./types"

export interface Props
  extends Omit<FormField<Record<string, unknown>>, "defaultValue">,
    Pick<
      AutocompleteProps,
      | "defaultValue"
      | "placeholder"
      | "multiple"
      | "disabledOptions"
      | "hideChips"
      | "renderChipsUnder"
      | "disableClearable"
      | "hideSelectedOptions"
      | "onOptionSelected"
      | "sortOptions"
      | "preventWriteToForm"
      | "clearInputOnSelect"
      | "blurOnSelect"
      | "startAdornment"
      | "loadingOptions"
    > {
  options: Option[]
}

const Select = React.forwardRef<any, Props>(function Select(props, ref) {
  return <Autocomplete {...props} ref={ref} disableFiltering />
})

export default Select
